import { render, staticRenderFns } from "./pourcentage.vue?vue&type=template&id=5e28e47c&scoped=true&"
import script from "./pourcentage.vue?vue&type=script&lang=js&"
export * from "./pourcentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e28e47c",
  null
  
)

export default component.exports